import { useState } from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { useFormBuilder } from '../context/FormBuilderContext';
import { FormRenderer } from './FormRenderer';

const WIDTHS: Record<string, number> = {
  desktop: 760,
  tablet: 500,
  mobile: 340,
};

export function PreviewDrawer({ onClose }: { onClose: () => void }) {
  const { document, fieldTypeRegistry } = useFormBuilder();
  const [device, setDevice] = useState<keyof typeof WIDTHS>('desktop');

  return (
    <Dialog title="Preview" onClose={onClose} width={Math.min(WIDTHS[device] + 80, window.innerWidth - 40)}>
      <div style={{ display: 'flex', gap: 'var(--kendo-spacing-1)', marginBottom: 'var(--kendo-spacing-3)', justifyContent: 'center' }}>
        {(Object.keys(WIDTHS) as (keyof typeof WIDTHS)[]).map((d) => (
          <Button key={d} fillMode={device === d ? 'solid' : 'outline'} size="small" onClick={() => setDevice(d)}>
            {d[0].toUpperCase() + d.slice(1)}
          </Button>
        ))}
      </div>
      <div
        style={{
          width: WIDTHS[device],
          maxWidth: '100%',
          margin: '0 auto',
          maxHeight: '65vh',
          overflowY: 'auto',
          border: '1px solid var(--kendo-color-border)',
          borderRadius: 'var(--kendo-border-radius-md)',
        }}
      >
        <FormRenderer
          document={document}
          mode="preview"
          fieldTypes={Object.values(fieldTypeRegistry)}
        />
      </div>
    </Dialog>
  );
}
